import React from 'react';
import CkEditorContain from '../../Componant/Editor/CkEditor';

const CkEditor = () => {
  return (
    <div className='page-body'>
      <CkEditorContain />
    </div>
  );
};

export default CkEditor;
